import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ReactGA from "react-ga4";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home.jsx";
import ContactUs from "./pages/ContactUs.jsx";
import LoanAgainstCars from "./pages/LoanAgainstCars.jsx";
import LoanAgainstGold from "./pages/LoanAgainstGold.jsx";
import LoanAgainstJewelry from "./pages/LoanAgainstJewellery.jsx";
import LoanAgainstLuxuryWatches from "./pages/LoanAgainstLuxuryWatches.jsx";
import AwoofMarketplace from "./pages/AwoofMarketplace.jsx";
import LuxuryLineCredit from "./pages/LuxuryLineCredit.jsx";
import PawnParkService from "./pages/PawnParkService.jsx";
import MoneyAdvice from "./pages/MoneyAdvice.jsx";
import WristwatchRepair from "./pages/WristwatchRepair.jsx";
import WeBuyWeSell from "./pages/WeBuyWeSell.jsx";

import PartnershipCollaboration from "./pages/PartnershipCollaboration.jsx";

import Blogs from "./pages/Blogs.jsx";
import BlogPost from "./components/BlogPost.jsx";

import AwoofMarketplaceGallery from "./pages/AwoofMarketplaceGallery";
import ProductDetail from "./pages/ProductDetail";

import ScrollToTop from "./components/ScrollToTop";
import CareersPage from "./pages/CareersPage.jsx";

import "./App.css";
const queryClient = new QueryClient();

const GA_MEASUREMENT_ID = "G-VLZME5JLPP";

const App = () => {
  useEffect(() => {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    ReactGA.send("pageview");
  }, []);

  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <Router>
          <Navbar />
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/loan-against-cars" element={<LoanAgainstCars />} />
            <Route
              path="/loan-against-jewelry"
              element={<LoanAgainstJewelry />}
            />
            <Route
              path="/loan-against-luxury-watches"
              element={<LoanAgainstLuxuryWatches />}
            />
            <Route path="/loan-against-gold" element={<LoanAgainstGold />} />
            <Route path="/awoof-marketplace" element={<AwoofMarketplace />} />
            <Route path="/luxury-line-credit" element={<LuxuryLineCredit />} />
            <Route path="/pawn-park-service" element={<PawnParkService />} />
            <Route path="/money-advice" element={<MoneyAdvice />} />
            <Route path="/wristwatch-repair" element={<WristwatchRepair />} />
            <Route path="/we-buy-we-sell" element={<WeBuyWeSell />} />
            <Route
              path="/partnership-collaboration"
              element={<PartnershipCollaboration />}
            />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blogs/:slug" element={<BlogPost />} />
            <Route path="/marketplace" element={<AwoofMarketplaceGallery />} />
            <Route
              path="/marketplace/product/:slug"
              element={<ProductDetail />}
            />
            <Route path="/careers" element={<CareersPage />} />
          </Routes>
          <Footer />
        </Router>
      </QueryClientProvider>
    </HelmetProvider>
  );
};

export default App;
